import { httpGet } from "@eres/rest";
import config from "./config";
import { ManagementProfile, OwnerCommitteeDetails, Property, Response, UnitProfile } from "./entities";
import { LocaleUtil } from "@eres/core";
import { getToken } from "@my-dld/utils/User";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { getConsumerId } from "../../../../configApp";

export async function getProperties() {
	return httpGet<Response<{ properties: Property[] }>>( config.mollakMeydaanAPI().endPoint() + "owner/properties" ).then( validateResponse );
}

export async function getUnitDetails( propertyId: number ) {
	return httpGet<Response<UnitProfile>>( config.mollakMeydaanAPI().endPoint() + `owner/property/${ propertyId }/profile/unit` ).then( validateResponse );
}

export async function getManagementProfile( propertyId: number ) {
	return httpGet<Response<ManagementProfile>>( config.mollakMeydaanAPI().endPoint() + `owner/property/${ propertyId }/profile/management` ).then( validateResponse );
}

export async function getOwnerCommitteeDetails( propertyId: number ) {
	return httpGet<Response<OwnerCommitteeDetails>>( config.mollakMeydaanAPI().endPoint() + `owner/property/${ propertyId }/profile/ownercommittee` ).then( validateResponse );
}

export function downloadStatement( propertyId: number ) {
	showLoading();
	const params = {
		"token": getToken() ?? "",
		"consumer-id": getConsumerId( config.mollakMeydaanAPI().endPoint() ) ?? "",
	};
	fetch( config.mollakMeydaanAPI().endPoint() + `owner/property/${ propertyId }/statement`, { headers: params } ).then( r => r.blob() )
	.then( blob => {
		let newBlob = new Blob( [ blob ], { type: "application/pdf" } );
		let url = window.URL.createObjectURL( newBlob );
		let a = document.createElement( "a" );
		a.href = url;
		a.download = propertyId + ".pdf";
		a.click();
		hideLoading();
	} ).catch( e => {
		showErrorMessage( e );
		hideLoading();
	} );
}

function validateResponse<T>( response: Response<T> ): Promise<T> {
	if ( response ) {
		let errors = response.validationErrorsList;
		if ( errors != null && Array.isArray( errors ) && errors.length > 0 ) {
			const message = errors.map( e => e.errorMessageSet ? LocaleUtil.getLocalValue( e.errorMessageSet ) : e.errorMessage ).join( "\n" ).trim();
			return Promise.reject( message );
		}
	}
	return Promise.resolve( response.response );
}
